import React from 'react';
import { FaExternalLinkAlt, FaEye, FaClock } from 'react-icons/fa';

const FeaturedWork = () => {
  const featuredArticles = [
    {
      title: "Blazers regret in passing on Cedric Coward grows as Yang Hansen becomes unplayable",
      category: "Draft Analysis",
      url: "https://ripcityproject.com/blazers-regret-passing-cedric-coward-grows-yang-hansen-unplayable",
      sessions: "59,552",
      engagementTime: "50s",
      viewsPerUser: "1.48",
    },
    {
      title: "Lakers already learning why Blazers were happy to dump Deandre Ayton",
      category: "Roster Analysis",
      url: "https://ripcityproject.com/lakers-learning-blazers-happy-dump-deandre-ayton",
      sessions: "57,014",
      engagementTime: "54s",
      viewsPerUser: "1.40",
    },
    {
      title: "5 Key Portland Trail Blazers that definitely shouldn't return next season",
      category: "Roster Analysis",
      url: "https://ripcityproject.com/posts/5-key-portland-trail-blazers-that-definitely-shouldn-t-return-next-season-01hy7qbsz7vx/1",
      sessions: "44,799",
      engagementTime: "2m 09s",
      viewsPerUser: "4.50",
    },
    {
      title: "8 Stars the Portland Trail Blazers missed drafting by a single pick",
      category: "Historical Analysis",
      url: "https://ripcityproject.com/posts/8-stars-portland-trail-blazers-missed-drafting-single-pick",
      sessions: "31,484",
      engagementTime: "2m 34s",
      viewsPerUser: "7.04",
    },
    {
      title: "Trail Blazers grant Damian Lillard his wish sooner than expected",
      category: "Breaking News",
      url: "https://ripcityproject.com/trail-blazers-grant-damian-lillard-wish-sooner-expected",
      sessions: "26,586",
      engagementTime: "51s",
      viewsPerUser: "1.44",
    },
    {
      title: "5 Reasons the Portland Trail Blazers won the Deni Avdija trade",
      category: "Trade Evaluation",
      url: "https://ripcityproject.com/posts/5-reasons-portland-trail-blazers-won-deni-avdija-trade/1",
      sessions: "24,999",
      engagementTime: "2m 11s",
      viewsPerUser: "3.24",
    }
  ];

  return (
    <section id="featured-work" className="featured-work">
      <div className="container">
        <h2 className="section-title">Featured Work</h2>

        <div className="featured-articles-grid">
          {featuredArticles.map((article, index) => (
            <div key={index} className="featured-article-card">
              <div className="article-header">
                <span className="article-category">{article.category}</span>
                <div className="article-metrics">
                  <div className="metric">
                    <FaEye />
                    <span>{article.sessions} views</span>
                  </div>
                  <div className="metric">
                    <FaClock />
                    <span>{article.engagementTime} avg. time</span>
                  </div>
                </div>
              </div>

              <div className="article-content">
                <h3 className="article-title">{article.title}</h3>


                <div className="article-link">
                  <a
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="article-link-btn"
                  >
                    <FaExternalLinkAlt />
                    Read Article
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturedWork;